import AnalyticsExpensesIcon from './component'

export default AnalyticsExpensesIcon
